"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketApiOperations = void 0;
var WebSocketApiOperations;
(function (WebSocketApiOperations) {
    WebSocketApiOperations[WebSocketApiOperations["CreatingConnectionToken"] = 0] = "CreatingConnectionToken";
})(WebSocketApiOperations || (exports.WebSocketApiOperations = WebSocketApiOperations = {}));
